import { useState } from 'react';

import { Badge, VStack } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import { FavoriteOrderButton } from 'components/favorite-order-button';
import Picture from 'components/picture';

import { ModalOrderDetails } from './modal-order-details';
import {
  BadgeContainer,
  CardContainer,
  ItemName,
  ItemThumbnailContainer,
  Price,
  StyledLink,
  ThumbnailBehind,
  ThumbnailBox,
} from './styled';
import { useOrderDetailsCard } from './use-order-details-card';

export const OrderDetailsCard = ({ serverOrder }: { serverOrder: IServerOrder }) => {
  const { formatMessage } = useIntl();
  const { itemHighlighted, totalPrice, totalItems } = useOrderDetailsCard({
    serverOrder,
  });
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  return (
    <CardContainer>
      <ItemThumbnailContainer>
        {Array.from({ length: 2 }).map((_, index) => (
          <ThumbnailBehind
            key={index}
            style={{
              transform: [{ rotate: index % 2 === 0 ? '12deg' : '-12deg' }],
            }}
          />
        ))}
        <ThumbnailBox>
          <BadgeContainer>
            <Badge minWidth="$5" width="$5" height="$5" variant="number-solid">
              {totalItems.toString()}
            </Badge>
          </BadgeContainer>
          {itemHighlighted && (
            <Picture
              image={itemHighlighted.image}
              accessibilityHidden
              width="$13.5"
              height="$13.5"
              alt={itemHighlighted.name}
            />
          )}
        </ThumbnailBox>
      </ItemThumbnailContainer>
      <VStack flex={1} marginLeft="$4">
        <Price>{totalPrice}</Price>
        <ItemName numberOfLines={1}>{itemHighlighted?.name}</ItemName>
        <StyledLink marginTop="$2" onPress={() => setIsDetailsModalOpen(true)}>
          {formatMessage({ id: 'viewDetails' })}
        </StyledLink>
      </VStack>
      <VStack alignSelf="flex-start">
        <FavoriteOrderButton order={serverOrder} />
      </VStack>

      <ModalOrderDetails
        serverOrder={serverOrder}
        showModal={isDetailsModalOpen}
        onCloseModal={() => setIsDetailsModalOpen(false)}
      />
    </CardContainer>
  );
};
